export type Right<R> = { _tag: "Right"; right: R };
export type Left<L> = { _tag: "Left"; left: L };
export type Either<R, L> = Right<R> | Left<L>;

export const right = <R>(value: R): Either<R, never> => ({
  _tag: "Right",
  right: value
});
export const left = <L>(value: L): Either<never, L> => ({
  _tag: "Left",
  left: value
});

export const isLeft = <R, L>(either: Either<R, L>): either is Left<L> =>
  either._tag === "Left";
export const isRight = <R, L>(either: Either<R, L>): either is Right<R> =>
  either._tag === "Right";

export const match = <R, L, A>(
  either: Either<R, L>,
  onLeft: (left: L) => A,
  onRight: (right: R) => A
): A => {
  if (isLeft(either)) {
    return onLeft(either.left);
  }
  return onRight(either.right);
};

export const map = <R, L, B>(
  either: Either<R, L>,
  fn: (value: R) => B
): Either<B, L> => {
  if (isRight(either)) {
    return right(fn(either.right));
  }
  return either;
};
